<template>
  <div class="small">
    <!-- バブル（上部） -->
    <div
      class="bubble-wrapper"
      :style="{'grid-template-columns': `${currentDiseaseRisk}fr ${100 - currentDiseaseRisk}fr`}"
    >
      <div class="bubble">
        <div class="bubble--inner-content bubble--inner-content__upper">
          <div class="bubble--inner-content__label">{{$t('aiPredictionReport.currentRisk')}}</div>
          <div>{{ currentDiseaseRisk }}%</div>
          <div class="bubble--inner-content__triangle">▼</div>
        </div>
      </div>
      <div></div>
    </div>

    <!-- バーチャート -->
    <div>
      <bar-chart :chartdata="chartdata" :options="options" :height="10" />
    </div>

    <!-- バブル（下部） -->
    <div
      class="bubble-wrapper"
      :style="{'grid-template-columns': `${currentDiseaseRisk + expectedDiseaseRisk}fr ${100 - (currentDiseaseRisk + expectedDiseaseRisk)}fr`}"
    >
      <div class="bubble">
        <div class="bubble--inner-content bubble--inner-content__lower">
          <div class="bubble--inner-content__triangle">▲</div>
          <div>{{ currentDiseaseRisk + expectedDiseaseRisk }}%</div>
          <div class="bubble--inner-content__label">{{$t('aiPredictionReport.estimatedRisk')}}</div>
        </div>
      </div>
      <div></div>
    </div>
  </div>
</template>


<script>
import VueTypes from "vue-types";
import BarChart from "./BarChart";

export default {
  components: {
    BarChart
  },
  props: {
    riskRate: VueTypes.isRequired,
    currentDiseaseRisk: VueTypes.number.isRequired,
    expectedDiseaseRisk: VueTypes.number.isRequired,
    riskIndex: VueTypes.number.isRequired
  },
  data() {
    return {
      options: {
        responsive: true,
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
          }
        },
        tooltips: {
          enabled: false
        },
        hover: {
          mode: null
        },
        legend: {
          display: false,
          fullWidth: false
        },
        scales: {
          yAxes: [
            {
              offsetGridLines: true,
              display: false,
              stacked: true,
              barThickness: 20
            }
          ],
          xAxes: [
            {
              offsetGridLines: true,
              display: false,
              stacked: true
            }
          ]
        }
      }
    };
  },
  computed: {
    chartdata() {
      return {
        labels: ["hoge"],
        datasets: [
          {
            backgroundColor: ["#96BF92"],
            data: [this.a]
          },
          {
            backgroundColor: ["#ECD460"],
            data: [this.b]
          },
          {
            backgroundColor: ["#DFAF81"],
            data: [this.c]
          },
          {
            backgroundColor: ["#CF7D8E"],
            data: [this.d]
          }
        ]
      };
    },
    a() {
      return Math.floor(this.riskRate[0]);
    },
    b() {
      return Math.floor(this.riskRate[1] - this.a);
    },
    c() {
      return Math.floor(this.riskRate[2] - (this.a + this.b));
    },
    d() {
      return Math.floor(100 - (this.a + this.b + this.c));
    }
  }
};
</script>

<style scoped>
.small {
  max-width: 80%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 60px;
  margin-bottom: 40px
}
.bubble-wrapper {
  display: grid;
  font-size: 1rem;
  justify-items: end;
}
.bubble {
  position: relative;
}
.bubble--inner-content {
  position: absolute;
  left: -100px;
  width: 200px;
}
.bubble--inner-content__upper {
  bottom: 50%;
}
.bubble--inner-content__lower {
  top: 50%;
}
.bubble--inner-content__triangle {
  color: #419ae0;
}
.bubble--inner-content__label {
  font-weight: bold;
}
</style>